import '@fontsource-variable/outfit';
import './styles/tokens/colors.css';
import './styles/tokens/typography.css';
import './styles/tokens/spacing.css';
import './styles/hud.css';
import './styles/interior.css';
import { startApp } from './app';
import { registerOffline } from './pwa';

const root = document.getElementById('app');
if (!root) throw new Error('Falta el elemento #app');
const app = startApp(root);
if (app) registerOffline(app.notices, { quiet: app.settings.shot });
